import { render, staticRenderFns } from "./DbTestConnection.vue?vue&type=template&id=f0f81c78&scoped=true&"
import script from "./DbTestConnection.vue?vue&type=script&lang=js&"
export * from "./DbTestConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f81c78",
  null
  
)

export default component.exports